import { Move, RotateCw } from 'lucide-react';
import { useRecoilState } from 'recoil';
import ToolbarButton from '~/components/toolbar/shared/ToolbarButton';
import { RegistrationMode } from '~/engine/tool/tools/RegistrationTool';
import {
    registrationModeState,
    selectedToolState,
} from '~/state/atoms/toolsAtoms';

interface RegistrationModeToolProps {
    isDisabled: boolean;
    onModeSelected?: () => void;
}

export default function RegistrationModeTool({
    isDisabled,
    onModeSelected,
}: RegistrationModeToolProps) {
    const [tool, setTool] = useRecoilState(selectedToolState);
    const [registrationMode, setRegistrationMode] = useRecoilState(
        registrationModeState
    );

    const handleModeSelect = (mode: RegistrationMode) => {
        setRegistrationMode((prev) => ({
            ...prev,
            mode,
        }));
        if (tool !== 'registration') {
            setTool('registration');
        }
        onModeSelected?.();
    };

    return (
        <>
            <ToolbarButton
                icon={<Move />}
                tooltip="Translation"
                tooltipPlacement="bottom"
                selected={
                    tool === 'registration' &&
                    registrationMode.mode === RegistrationMode.TRANSLATION
                }
                disabled={isDisabled}
                onClick={() => handleModeSelect(RegistrationMode.TRANSLATION)}
                data-testid="registration-translate-mode"
            />
            <ToolbarButton
                icon={<RotateCw />}
                tooltip="Rotation"
                tooltipPlacement="bottom"
                selected={
                    tool === 'registration' &&
                    registrationMode.mode === RegistrationMode.ROTATION
                }
                disabled={isDisabled}
                onClick={() => handleModeSelect(RegistrationMode.ROTATION)}
                data-testid="registration-rotate-mode"
            />
        </>
    );
}
